import moment from 'moment-timezone';

import { formatTime } from 'utils/helpers';

export const getFormattedBusinessHours = (hours: number) =>
  formatTime(moment.utc().startOf('day').add(hours, 'hours'));
